/*
 * Homepage quote carousel.
 *
 * One quote is shown at a time; the arrows and dots move the track. Slides that are out of
 * view are hidden from assistive technology so the section reads as a single quote.
 */
class JsHomeQuote extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-quote-track]');
    this.slides = Array.from(this.querySelectorAll('[data-quote-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-quote-dot]'));
    if (!this.track || this.slides.length === 0) return;

    this.index = 0;

    this.querySelector('[data-quote-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[data-quote-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.render();
  }

  go(next) {
    const count = this.slides.length;
    // wrap around, so the arrows never dead-end
    this.index = (next + count) % count;
    this.render();
  }

  render() {
    this.track.style.transform = `translateX(-${this.index * 100}%)`;

    this.slides.forEach((slide, i) => {
      if (i === this.index) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
    });
  }
}

if (!window.customElements.get('js-home-quote')) {
  window.customElements.define('js-home-quote', JsHomeQuote);
}
